export const formatNumber = (num) => {
  return new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 3,
  }).format(num);
};


export const formatNumberWithCommas = (value) => {
  const num = parseFloat(value);
  return isNaN(num) ? '——' : num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatCost = (value) => {
  const rounded = Math.round(value * 100) / 100
  const str = rounded.toString()
  return str.endsWith('.0') ? str.slice(0, -2) : str
}

/**
 * Форматує число для відображення ціни: перші 2 цифри через кому, решта по 3 через крапку
 * @param {number|string} num - Число для форматування
 * @returns {string} - Відформатоване число
 * @example formatPriceNumber(1234567.89) => "12,345.67.89"
 */
export const formatPriceNumber = (num) => {
  const str = num.toString();
  const parts = str.split('.');

  // Форматуємо цілу частину
  let integerPart = parts[0];
  if (integerPart.length > 2) {
    // Перші 2 цифри відокремлюємо комою, решту групуємо по 3 через крапку
    const firstTwo = integerPart.slice(0, 2);
    const rest = integerPart.slice(2);
    // Групуємо решту по 3 цифри з крапками
    const groupedRest = rest.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    integerPart = firstTwo + groupedRest;
  }

  // Додаємо дробову частину якщо є: між цілою та дробовою ставимо КРАПКУ
  return parts.length > 1 ? integerPart + '.' + parts[1] : integerPart;
};